import React from "react";
import { Modal, Button, Typography, Flex } from "antd";
const { Title, Text } = Typography;

const WhatsAppConnectionModal = ({ open, onCancel, onSelect }) => {
  return (
    <Modal
      title={null}
      open={open}
      onCancel={onCancel}
      footer={null}
      centered
      width={700}
      bodyStyle={{ padding: '40px' }}
    >
      <div className="text-center mb-10">
        <Title level={4} style={{ marginBottom: '12px' }}>Connect WhatsApp Business Account</Title>
        <Text type="secondary" style={{ fontSize: '14px' }}>
          Choose how you want to connect your WhatsApp Business Platform
        </Text>
      </div>

      <Flex gap={32} align="stretch">
        {/* BSP Card */}
        <div className="flex-1 p-8 border border-gray-100 rounded-3xl bg-white hover:border-[#6940F2] hover:shadow-lg transition-all flex flex-col items-center">
          {/* <div className="mb-6 p-5 bg-[#6940F210] rounded-2xl">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" fill="#6940F2"/>
              <circle cx="12" cy="8" r="2" fill="#6940F2"/>
              <circle cx="8" cy="15" r="2" fill="#6940F2"/>
              <circle cx="16" cy="15" r="2" fill="#6940F2"/>
              <path d="M10.5 13.5L11.25 9.5M13.5 13.5L12.75 9.5M9.5 15H14.5" stroke="#6940F2" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </div> */}
          <Title level={5} style={{ marginBottom: '12px' }}>Connect with BSP</Title>
          <ul className="text-left mb-8 text-gray-400 list-disc pl-5" style={{ fontSize: '14px', lineHeight: '1.8' }}>
            <li>Payment is connected with Gainwix and its business partner.</li>
            <li>Credit line is added with us, purchase credits.</li>
          </ul>
          <div className="mt-auto w-full">
             <Button 
                type="primary" 
                block 
                className="h-11 rounded-xl bg-[#6940F2] hover:bg-[#5835cc] border-none font-medium"
                onClick={() => onSelect('bsp')}
              >
                Connect with Solution Partner
              </Button>
          </div>
        </div>

        {/* Meta Direct Card */}
        <div className="flex-1 p-8 border border-gray-100 rounded-3xl bg-white hover:border-[#1778F2] hover:shadow-lg transition-all flex flex-col items-center">
          {/* <div className="mb-6 p-5 bg-[#1778F210] rounded-2xl">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 17H8M8 17L11 20M8 17L11 14M8 7H16M16 7L13 4M16 7L13 10" stroke="#1778F2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div> */}
          <Title level={5} style={{ marginBottom: '12px' }}>Connect with Meta</Title>
          <ul className="text-left mb-8 text-gray-400 list-disc pl-5" style={{ fontSize: '14px', lineHeight: '1.8' }}>
            <li>Payment needs to be done manually in Meta.</li>
            <li>You need to add payment method in Meta.</li>
          </ul>
          <div className="mt-auto w-full">
            <Button 
              block 
              className="h-11 rounded-xl border-[#1778F2] text-[#1778F2] hover:bg-[#1778F208] font-medium"
              onClick={() => onSelect('meta')}
            >
              Connect with Meta
            </Button>
          </div>
        </div>
      </Flex>
    </Modal>
  );
};

export default WhatsAppConnectionModal;
